import { useCallback } from "react";

import { Trans } from "@lingui/react/macro";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { AccountSecurityBanner } from "@/components/account/account-security-banner";
import { PageHeader } from "@/components/layout/page-header";
import {
  NOTIFICATIONS_VALID_TABS,
  NotificationsView,
  type NotificationsTab,
} from "@/components/notifications/notifications-view";

interface NotificationsSearch {
  tab: NotificationsTab;
}

export const Route = createFileRoute("/_authenticated/account/user/notifications")({
  validateSearch: (search: Record<string, unknown>): NotificationsSearch => {
    const raw = typeof search.tab === "string" ? search.tab : "";
    return {
      tab: NOTIFICATIONS_VALID_TABS.includes(raw as NotificationsTab)
        ? (raw as NotificationsTab)
        : "all",
    };
  },
  component: UserNotificationsPage,
});

function UserNotificationsPage() {
  const { tab: activeTab } = Route.useSearch();
  const navigate = useNavigate();

  const setActiveTab = useCallback(
    (key: NotificationsTab) =>
      navigate({ to: "/account/user/notifications", search: { tab: key } }),
    [navigate],
  );

  return (
    <div className="flex min-h-0 flex-1 flex-col gap-4">
      <PageHeader
        title={<Trans>Notifications</Trans>}
        description={<Trans>Status updates, action items, and alerts.</Trans>}
      />
      <NotificationsView workspaceType="user" activeTab={activeTab} onTabChange={setActiveTab} />
      <AccountSecurityBanner />
    </div>
  );
}
